module.exports = __webpack_public_path__ + "img/105037.6d496198.png";